import React, { ChangeEvent, useState } from "react";
import classes from "./CheckBox.module.scss";
import { RadioType } from "../radio-button/RadioButton";

export const THEME_ITEMS: CheckBoxItem[] = [
  { id: "1", name: "家計改善", value: false },
  { id: "2", name: "NISA・イデコ", value: false },
  { id: "3", name: "資産運用", value: false },
  { id: "4", name: "保険", value: false },
  { id: "5", name: "教育資金", value: false },
  { id: "6", name: "老後資金", value: false },
  { id: "7", name: "住宅購入", value: false },
  { id: "8", name: "住宅ローン", value: false },
  { id: "9", name: "相続", value: false },
  { id: "10", name: "転職", value: false },
  { id: "11", name: "借金返済・債務整理", value: false },
];

export const CONCERN_ITEMS: CheckBoxItem[] = [
  { id: "12", name: "教育資金が不安", value: false },
  { id: "13", name: "老後資金が不安", value: false },
  { id: "14", name: "家計を見直したい", value: false },
];

type CheckBoxProps = {
  label: string;
  subLabel?: string;
  checkItem: CheckBoxItem[];
  onChange: (args: CheckBoxItem) => void;
};

export type CheckBoxItem = {
  id: string;
  name: string;
  value: boolean;
};

const CheckBox = (props: CheckBoxProps) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const target = props.checkItem.filter((i) => i.id === e.target.id)[0];
    props.onChange({
      id: e.target.id,
      name: target.name,
      value: !target.value,
    });
  };
  const checked = (item: CheckBoxItem) => {
    // TODO: チェックした際に背景色をつけたいが実装できていない
    return {};
  };
  return (
    <div className={classes.container}>
      <div className={classes.label}>{props.label}</div>
      <div className={classes.subLabel}>{props.subLabel}</div>
      <div className={classes.checkItemContainer}>
        {props.checkItem.map((item, index) => (
          <div
            key={index}
            className={classes.checkItem}
            style={checked(item)}
            onChange={onChange}
          >
            <input
              className={classes.checkbox}
              type="checkbox"
              id={item.id}
              name={item.name}
            />
            <label htmlFor={item.id} className={classes.checkboxLabel}>
              {item.name}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckBox;
